module.exports = __webpack_public_path__ + "assets/b5b20de77f44f4615673c5664748d837.png";